import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { PageBanner } from "../../../components";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Container, Grid, makeStyles, Button, Box } from "@material-ui/core";
import { MainAdminBookDetail, Reviews, Rating, RelatedBooks } from "../../Book/components";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { backend } from "../../../api";
import { Skeleton } from "@material-ui/lab";
import { promotedBy } from "../../../redux-store/adCard/actions";
import { useMyContext } from "../../../contextApi/context";

const useStyles = makeStyles((theme) => ({
  bookTitle: {
    fontSize: "36px",
    fontWeight: "600",
    marginTop: "0px",
  },
  input: {
    padding: 15,
    borderRadius: "2px",
  },
  addBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    fontSize: "12px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
}));

function AdminBookDetail() {
  const { cartItems } = useMyContext();
  const state = useSelector((state) => state.customer);
  const { currentUser } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const params = useParams();
  const classes = useStyles();
  const [currentBook, setCurrentBook] = useState({});
  const [author, setAuthor] = useState();
  const [wishlist, setWishlist] = useState();
  const [isDisable, setIsDisable] = useState(false);

  useEffect(() => {
    let search = window.location.search;
    let member = new URLSearchParams(search).get("promoted_by");
    if (member) {
      dispatch(promotedBy(member));
    }
    fetchCurrentBook();
    if (currentUser.user) {
      fetchWishist();
    }
  }, []);
  useEffect(() => {
    checkIfInCart();
  }, [cartItems]);

  const checkIfInCart = () => {
    const isInCart = cartItems.some((item) => item?.bookId && item?.bookId?._id === params.bookId);
    setIsDisable(isInCart);
  };

  const fetchCurrentBook = () => {
    backend
      .get(`/book?_id=${params.bookId}`)
      .then((res) => {
        setAuthor(res.data.data[0].author);
        setCurrentBook(res.data.data[0]);
      })
      .catch((err) => {
        let message = err.response ? err.response.data.message : err.message;
        toast.error(message);
      });
  };
  
  const fetchWishist = () => {
    backend
      .get(`/wishlist?customer=${currentUser.user?._id}`)
      .then((res) => {
        setWishlist(res.data.data[0]);
      })
      .catch((err) => {
        let message = err.response ? err.response.data.message : err.message;
        toast.error(message);
      });
  };

  return (
    <Fragment>
      <Helmet>
        <title>Book - d2p</title>
      </Helmet>
      <ToastContainer />
      <PageBanner title={"Book"} image="/assets/images/bg4.jpg" />

      <Container style={{ marginTop: "50px", marginBottom: "50px" }}>
        {currentBook ? (
          <Box>
            <MainAdminBookDetail
              currentBook={currentBook}
              user={currentUser}
              wishlist={wishlist}
              author={author}
              cartItems={cartItems}
              isDisable={isDisable}
            />
            {currentBook.reviews && (
              <Reviews
              bookTitle={currentBook.book_title}
              currentReviews={currentBook.reviews}
              rating={currentBook.rating}
              user={currentUser}
            />
            )}
            {currentUser.user && (
              <Rating currentBook={currentBook} setBook={setCurrentBook} />
            )}
          </Box>
        ) : (
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={5}>
                <Skeleton
                  variant="rect"
                  width="60%"
                  height={450}
                  style={{ margin: "0 auto" }}
                  animation
                />
              </Grid>
              <Grid xs={12} sm={6} md={6} lg={7}>
                <Skeleton
                  variant="rect"
                  width="90%"
                  height={100}
                  animation="wave"
                />
                <Skeleton
                  animation="wave"
                  width="90%"
                  style={{ marginTop: 40 }}
                />
                <Skeleton animation="wave" width="75%" />
                <Skeleton animation="wave" width="60%" />
                <Skeleton animation="wave" width="45%" />

                <Skeleton
                  animation="wave"
                  width={200}
                  height={40}
                  style={{ marginTop: 30 }}
                />
                <Skeleton animation="wave" width={200} height={40} />
                <Skeleton animation="wave" width={200} height={40} />

                <Box display="flex" mt={5}>
                  <Skeleton
                    variant="rect"
                    width="40%"
                    height={40}
                    animation="wave"
                  />
                  <Skeleton
                    variant="rect"
                    width="40%"
                    height={40}
                    style={{ marginLeft: 20 }}
                    animation="wave"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
      </Container>
    </Fragment>
  );
}

export default AdminBookDetail;
